import { Navigate, useLocation } from 'react-router-dom';
import ComingSoon from '@/components/ComingSoon';

const PortalPrivateRoute = ({ children }: { children: React.ReactNode }) => {
  // Portal features have no backend API yet — show Coming Soon
  return <ComingSoon featureName="End-User Portal" description="Self-service portal for end users is under development. Backend APIs for portal login, device enrollment, and approval workflows are not yet available." />;
};

export default PortalPrivateRoute;
